export default __webpack_public_path__ + "static/media/logo.1fe37376.png";